import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch } from '../../../store'
import { JWTRegex } from '../../utils/constants'
import { getSecureKey } from '../../utils/helperFunctions'
import {
  useSalesforceContext,
  getClaimsFromToken,
  hydrateAuthorizationClaims,
  isHubspotExternalAppPath,
} from '@labrav/common'

/**
 * JWT-in-URL flows under `/external-apps/*` never mount `SecureRoutesWrapper`.
 * Reuse the same hydrate as the main app when a secureKey JWT is present.
 */
export const ExternalAppsAuthSourceSync = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const { loading, isInSalesforceContext } = useSalesforceContext()

  useEffect(() => {
    const hubspotIframe = isHubspotExternalAppPath(location.pathname)
    if (!hubspotIframe && (loading || isInSalesforceContext)) {
      return
    }
    if (!location.pathname.startsWith('/external-apps/')) {
      return
    }

    const secureKey = getSecureKey()
    if (!secureKey || !new RegExp(JWTRegex).test(secureKey)) {
      return
    }

    try {
      const claims = getClaimsFromToken(secureKey)
      let scopes = ['all:labra:write']
      if (claims.scopes && claims.scopes.length > 0) {
        scopes = claims.scopes
      }
      dispatch(
        hydrateAuthorizationClaims({
          source: 'url-jwt',
          partnerId: claims.partnerId,
          partnerUserId: claims.partnerUserId,
          roles: claims.roles,
          scopes,
          isAuthenticated: true,
          claimsLoaded: true,
        })
      )
    } catch (err) {
      console.error(
        'ExternalAppsAuthSourceSync: malformed or invalid JWT when hydrating authorization',
        err
      )
    }
  }, [dispatch, loading, isInSalesforceContext, location.pathname])

  return null
}
